import React from 'react';
import { withRouter } from 'react-router';
import { Link, NavLink, RouteComponentProps } from 'react-router-dom';

function NavBar({ history }: RouteComponentProps) {
  return (
    <nav className="navbar navbar-expand-sm bg-dark navbar-dark mb-2">
      <Link to="/" className="navbar-brand">
        <img src="/favicon.ico" className="navbar-brand-logo" alt="Evil Genius Labs Logo" />
        Evil Genius Labs
      </Link>

      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>

      <div className="collapse navbar-collapse" id="navbarCollapse">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item">
            <NavLink className="nav-link" to="/">
              Discovery
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default withRouter(NavBar);
